import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import './Concept.css'

class Concept extends Component {
    constructor(props) {
      super(props)
      this.state = {isOpened: false}
      this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
      this.setState(prevState => ({
        isOpened: !prevState.isOpened
      }));

      if (!this.state.isOpened) {
        ReactDOM.findDOMNode(this.refs.heada).scrollIntoView({
          block: "start", 
          inline: "nearest", 
          behavior: "smooth"
        })
      }
    }

    render() {
      return (
        <div className={this.state.isOpened ? 'active' : null}>
        <h2 className="heada" ref="heada" onClick={this.handleClick}>{this.props.hnm}</h2>
        <div className="container prereq">
          {this.props.children}
          <div className="boundary"></div>
        </div>
        </div>
      )
    }   
}
export default Concept


// WEBPACK FOOTER //
// ./src/Prerequisites/Concept/Concept.js